import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {setQuotes} from "../../../actions/roomsFunctions";
import {changeSqftFeaturesPopup, setSqftMeasureUnit, setSquareFeet} from "../../../actions/sqftFunctions";
import {setMaterialsPageSubSteps} from "../../../actions/selectionFunctions";
import {
  changeCartItemQuantity,
  changeSelectionInfoQuantity,
  setCameFromPage,
  toggleSelectionFeatureInfo
} from "../../../actions/actionFunctions";
import WithAddToQuote from "../hocs/withAddToQuote";

const SqftFooterAddToQuoteButton = (props) => {

  return (
    <WithAddToQuote props={props}>
      {(handleAddToQuoteClick) => (
        <button data-id="nav_add_to_quote" className="add-to-quote ui-button10 ui-button10--secondary" onClick={() => handleAddToQuoteClick()}>
          <span className="add-to" data-text="sqft.footer.buttonAddToQuote">
            <FormattedMessage id={"sqft.footer.buttonAddToQuote"}/>
          </span>
        </button>
      )}
    </WithAddToQuote>
  )
};

const mapStateToProps = (store) => ({
  measureUnit: store.sqftState.measureUnit,
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
  quotes: store.quotesState.quotes,
  cartItems: store.cartState.cartItems,
  selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  sqftVisited: store.sqftState.sqftFeaturesPopup.visited,
  isSlabToolVisited: store.sqftSlabState.isSlabToolVisited,
  useSqftCartPopup: store.sqftState.sqftFeaturesPopup.enabled,
  cameFromPage: store.cartState.cameFromPage
});

const mapDispatchToProps = {
  setQuotes,
  setSquareFeet,
  setMaterialsPageSubSteps,
  changeSqftFeaturesPopup,
  toggleSelectionFeatureInfo,
  setCameFromPage,
  changeCartItemQuantity,
  changeSelectionInfoQuantity,
  setSqftMeasureUnit,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftFooterAddToQuoteButton);
